import React from 'react';
import { compose, graphql } from 'react-apollo';
import _ from 'lodash';
import gql from 'graphql-tag';
import { withRouter } from 'react-router';
import {
  Button,
  Form,
  Input,
  Divider,
  Message,
  Dropdown,
  Transition,
} from 'semantic-ui-react';
import {
  AUTH_TOKEN,
  GUEST_TOKEN,
  REGISTERED_COMPLETE_PROFILE,
} from 'config/constants';
import { FormattedMessage, injectIntl } from 'react-intl';
import FbLoginButton from 'components/FbLoginButton';
import GoogleLoginButton from 'components/GoogleLoginButton';

import WRAPPER_QUERY from 'containers/LegacyCartPage/graphql/ordersWrapperQuery.gql';
import CART_QUERY from 'containers/LegacyCartPage/graphql/legacyCartQuery.gql';

import { reportRegisterationAnalytics } from '../Helpers/actions';

import AuthUserFragment from '../graphql/userFragment.gql';
import messages from '../messages';
// import HeroMsg from '../HeroMsg';

const IS_TOKEN = gql`
  query IsToken {
    isToken
  }
`;
const IS_LOGGED_IN = gql`
  query IsLoggedIn {
    isLoggedIn
  }
`;
const USER_QUERY = gql`
  query User {
    user {
      ...AuthUserFragment
    }
  }
  ${AuthUserFragment}
`;

const COUNTRY_OPTIONS = (locale) => [
  {
    key: 'EG',
    value: 1,
    text: locale === 'ar' ? 'مصر' : 'Egypt',
  },
  {
    key: 'SA',
    value: 421,
    text: locale === 'ar' ? 'المملكة العربية السعودية' : 'Saudi Arabia',
  },
  {
    key: 'AE',
    value: 461,
    text: locale === 'ar' ? 'الإمارات العربية المتحدة' : 'United Arab Emirates',
  },
];

class Register extends React.Component {
  constructor(props) {
    super(props);

    const country = _.find(COUNTRY_OPTIONS(this.props.intl.locale), {
      key: this.props.user.country.iso_code,
    });

    this.state = {
      loading: false,
      email: '',
      password: '',
      password_confirmation: '',
      phone_number: '',
      country,
      validation_error: false,
      validation_error_msg: 'Password and password confirmation do not match',
      registeration_error: false,
      registeration_error_msg: '',
      social_auth_token: '',
      expires_at: 0,
      provider: '',
      formErrors: [],
      fieldsErrors: [],
    };
  }

  componentDidMount() {
    this.emailInput.focus();
  }

  componentWillReceiveProps(newProps) {
    if (newProps.message) {
      this.setState({
        registeration_error: true,
        registeration_error_msg: newProps.message,
      });
    }
  }

  validateEmail = () => {
    const re = /\S+@\S+\.\S+/;
    return re.test(this.state.email);
  };

  validatePassword = () =>
    this.state.password && this.state.password.length > 5;

  validatePasswordConfirmation = () => {
    const { password_confirmation: passConfirm, password } = this.state;
    return passConfirm === password;
  };

  _confirm = async () => {
    this.setState({ formErrors: [], fieldsErrors: [] });

    if (!this.isValidForm()) {
      return null;
    }

    this.setState({ loading: true });

    const {
      country: { value: country_id },
      email,
      password,
      phone_number
    } = this.state;

    const result = await this.props.registerUser({
      variables: {
        country_id,
        email,
        password,
        phone_number,
      },
      update: (proxy, { data: { register } }) => {
        window.isLoggedIn = true;

        localStorage.setItem(AUTH_TOKEN, register.token);
        localStorage.removeItem(GUEST_TOKEN);
        window.google.accounts.id.cancel();

        // Write our data back to the cache.
        proxy.writeQuery({
          query: IS_TOKEN,
          data: {
            isToken: !!register.token,
          },
        });
        proxy.writeQuery({
          query: IS_LOGGED_IN,
          data: {
            isLoggedIn: !!register.token,
          },
        });
      },
      refetchQueries: () => [
        { query: USER_QUERY },
        { query: CART_QUERY },
        { query: WRAPPER_QUERY },
      ],
      awaitRefetchQueries: true,
      errorPolicy: 'all',
    });

    this.setState({
      loading: false,
    });
    localStorage.setItem(REGISTERED_COMPLETE_PROFILE, true);

    const user = result.data.register;

    if (!!result.errors && result.errors.length) {
      this.setState({ formErrors: [result.errors[0].message], loading: false });
    } else if (
      user &&
      typeof user.first_signup_type === 'string' &&
      user.first_signup_type.length > 0
    ) {
      reportRegisterationAnalytics(user.first_signup_type);
    }

    if (user) {
      if (this.props.handleClose) {
        this.props.handleClose();
      }

      if (this.props.redirectTo) {
        if (this.props.redirectTo !== 'nothing') {
          this.props.history.push(this.props.redirectTo);
        }
      } else {
        this.props.history.push('/');
      }
    }
  };

  updateCountry = (e, country) => {
    this.setState({ country });
  };

  updatePhoneNumber = (e, data) => {
    this.setState({ phone_number: data.value });
  };

  updatePassword = (e, data) => {
    this.setState({ password: data.value });
    this.checkPasswordsEquality(this.state.password_confirmation, data.value);
  };

  updatePasswordConfirmation = (e, data) => {
    this.setState({ password_confirmation: data.value });
    this.checkPasswordsEquality(this.state.password, data.value);
  };

  checkPasswordsEquality = (pass, passConfirm) => {
    if (pass !== passConfirm) {
      this.setState({ validation_error: true });
    } else {
      this.setState({ validation_error: false });
    }
  };

  isValidForm = () => {
    const errors = [];
    const fieldsErrors = [];

    if (!this.validateEmail()) {
      errors.push('Email is not valid');
      fieldsErrors.push('email');
    }

    if (!this.validatePassword()) {
      errors.push('Password should be 6 characters at least');
      fieldsErrors.push('password');
    }

    if (!this.validatePasswordConfirmation()) {
      errors.push('Password and password confirmation do not match');
      fieldsErrors.push('password_confirmation');
    }

    if (fieldsErrors.length) this.setState({ fieldsErrors });
    if (errors.length) this.setState({ formErrors: errors });

    return errors.length === 0;
  };

  render() {
    if (this.props.visible === false) {
      return null;
    }

    return (
      <div>
        <Form
          error={this.state.fieldsErrors.length > 0}
          loading={this.state.loading}
          style={{
            textAlign: this.props.intl.locale === 'ar' ? 'right' : 'left',
            direction: this.props.intl.locale === 'ar' ? 'right' : 'left',
          }}
        >
          {/* {!this.props.isPage && <HeroMsg />} */}

          <Divider horizontal>
            <FormattedMessage {...messages.createAccountDivider} />
          </Divider>

          <Transition
            visible={this.state.formErrors.length > 0}
            animation="scale"
          >
            <Message
              error
              list={this.state.formErrors}
              style={{
                textAlign: this.props.intl.locale === 'ar' ? 'right' : 'left',
                direction: this.props.intl.locale === 'ar' ? 'right' : 'left',
              }}
            />
          </Transition>

          <GoogleLoginButton />
          <FbLoginButton />

          <Divider horizontal>
            <FormattedMessage {...messages.or} />
          </Divider>

          <Form.Field error={this.state.fieldsErrors.indexOf('email') > -1}>
            <label
              htmlFor="presentation"
              style={{
                textAlign: this.props.intl.locale === 'ar' ? 'right' : 'left',
                direction: this.props.intl.locale === 'ar' ? 'right' : 'left',
              }}
            >
              <FormattedMessage {...messages.email} />
            </label>
            <Input
              ref={(e) => {
                this.emailInput = e;
              }}
              type="email"
              placeholder="example@email.com"
              onChange={(e, data) => this.setState({ email: data.value })}
              input={
                <input
                  style={{
                    textAlign:
                      this.props.intl.locale === 'ar' ? 'right' : 'left',
                    direction:
                      this.props.intl.locale === 'ar' ? 'right' : 'left',
                  }}
                />
              }
            />
          </Form.Field>

          <Form.Field error={this.state.fieldsErrors.indexOf('password') > -1}>
            <label
              htmlFor="presentation"
              style={{
                textAlign: this.props.intl.locale === 'ar' ? 'right' : 'left',
                direction: this.props.intl.locale === 'ar' ? 'right' : 'left',
              }}
            >
              <FormattedMessage {...messages.password} />
            </label>
            <Input
              type="password"
              placeholder={this.props.intl.formatMessage({
                ...messages.passwordPlaceHolder,
              })}
              onChange={this.updatePassword}
              input={
                <input
                  style={{
                    textAlign:
                      this.props.intl.locale === 'ar' ? 'right' : 'left',
                    direction:
                      this.props.intl.locale === 'ar' ? 'right' : 'left',
                  }}
                />
              }
            />
          </Form.Field>

          <Form.Field
            error={
              this.state.fieldsErrors.indexOf('password_confirmation') > -1
            }
          >
            <label
              htmlFor="presentation"
              style={{
                textAlign: this.props.intl.locale === 'ar' ? 'right' : 'left',
                direction: this.props.intl.locale === 'ar' ? 'right' : 'left',
              }}
            >
              <FormattedMessage {...messages.passwordConfirm} />
            </label>
            <Input
              type="password"
              placeholder={this.props.intl.formatMessage({
                ...messages.passwordPlaceHolder,
              })}
              onChange={this.updatePasswordConfirmation}
              input={
                <input
                  style={{
                    textAlign:
                      this.props.intl.locale === 'ar' ? 'right' : 'left',
                    direction:
                      this.props.intl.locale === 'ar' ? 'right' : 'left',
                  }}
                />
              }
            />
          </Form.Field>

          <Form.Field>
            <label>
              <FormattedMessage {...messages.phoneNumber} />
            </label>
            <Input
              placeholder={this.props.intl.formatMessage({
                ...messages.optional,
              })}
              onChange={this.updatePhoneNumber}
              input={
                <input
                  style={{
                    textAlign:
                      this.props.intl.locale === 'ar' ? 'right' : 'left',
                    direction:
                      this.props.intl.locale === 'ar' ? 'right' : 'left',
                  }}
                />
              }
              type="tel"
            />
          </Form.Field>

          <Form.Field>
            <label
              htmlFor="presentation"
              style={{
                textAlign: this.props.intl.locale === 'ar' ? 'right' : 'left',
                direction: this.props.intl.locale === 'ar' ? 'right' : 'left',
              }}
            >
              <FormattedMessage {...messages.countryText} />
            </label>
            <Dropdown
              placeholder={this.props.intl.formatMessage({
                ...messages.selectCountryText,
              })}
              fluid
              search
              selection
              options={COUNTRY_OPTIONS(this.props.intl.locale)}
              value={this.state.country.value}
              onChange={this.updateCountry}
              style={{
                textAlign: this.props.intl.locale === 'ar' ? 'right' : 'left',
                direction: this.props.intl.locale === 'ar' ? 'right' : 'left',
              }}
            />
          </Form.Field>

          <Form.Field>
            <Button color="blue" fluid onClick={this._confirm}>
              <FormattedMessage {...messages.createAccountButtonText} />
            </Button>
          </Form.Field>
        </Form>
        <br />
        <Button
          size="tiny"
          as="a"
          basic
          fluid
          onClick={(e) => this.props.goTo('login', e)}
        >
          <b>
            <FormattedMessage {...messages.askToLogin} />
          </b>
        </Button>
      </div>
    );
  }
}

const SIGNUP_MUTATION = gql`
  mutation registerUser($email: String!, $password: String!, $country_id: ID!, $phone_number: String!) {
    register(
      sign_up_data: {
        user_info: { country_id: $country_id, phone_number_attributes: { number: $phone_number } }
        auth: { email: $email, password: $password }
      }
    ) {
      id
      token
      first_signup_type
    }
  }
`;

const COUNTRY_CODE_QUERY = gql`
  query CountryCode {
    geo {
      countryCode
    }
  }
`;

export default compose(
  injectIntl,
  withRouter,
  graphql(USER_QUERY, {
    options: { fetchPolicy: 'cache-only' },
    props: ({ data: { user } }) => ({ user }),
  }),
  graphql(SIGNUP_MUTATION, {
    name: 'registerUser',
  }),
  graphql(COUNTRY_CODE_QUERY, {
    name: 'countryCode',
    options: { fetchPolicy: 'cache-only' },
  })
)(Register);



// WEBPACK FOOTER //
// ./app/containers/Auth/Register/index.js